import { DateTime } from 'luxon';

export function parseBloombergDateTime(
    bloombergDateTime: string | Date
): number {
    if (bloombergDateTime instanceof Date) {
        return bloombergDateTime.getTime();
    }
    const dateTime = DateTime.fromISO(bloombergDateTime, { zone: 'UTC' });
    return dateTime.toJSDate().getTime();
}

export function toDateTimeStr(date: Date): string {
    const dateTime = DateTime.fromJSDate(date);
    return dateTime.toFormat(`yyyy-MM-dd'T'HH:mm:ss`);
}
